export default "__VITE_ASSET__Sds1n7DE__"